import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/esnext.set.add-all.js";
import "core-js/modules/esnext.set.delete-all.js";
import "core-js/modules/esnext.set.difference.js";
import "core-js/modules/esnext.set.every.js";
import "core-js/modules/esnext.set.filter.js";
import "core-js/modules/esnext.set.find.js";
import "core-js/modules/esnext.set.intersection.js";
import "core-js/modules/esnext.set.is-disjoint-from.js";
import "core-js/modules/esnext.set.is-subset-of.js";
import "core-js/modules/esnext.set.is-superset-of.js";
import "core-js/modules/esnext.set.join.js";
import "core-js/modules/esnext.set.map.js";
import "core-js/modules/esnext.set.reduce.js";
import "core-js/modules/esnext.set.some.js";
import "core-js/modules/esnext.set.symmetric-difference.js";
import "core-js/modules/esnext.set.union.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineComponent as _defineComponent } from 'vue';
import { getCurrentInstance } from 'vue';
import { EU_TAXONOMY_ICON_BY_TYPE, EU_TAXONOMY_LABEL_KEY_BY_TYPE } from '~/functions/impact-classification';
export default /*#__PURE__*/_defineComponent({
  __name: 'GhgImpactFrameworks',
  props: {
    sdgTargets: {
      default: function _default() {
        return [];
      }
    },
    euTaxonomy: {
      default: null
    },
    irisCategories: {
      default: function _default() {
        return [];
      }
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var _ref = getCurrentInstance(),
      proxy = _ref.proxy;
    var sdgIds = computed(function () {
      var _props$sdgTargets;
      var ids = ((_props$sdgTargets = props.sdgTargets) !== null && _props$sdgTargets !== void 0 ? _props$sdgTargets : []).map(function (target) {
        return target === null || target === void 0 ? void 0 : target.sdgId;
      }).filter(function (id) {
        return typeof id === 'number';
      });
      return Array.from(new Set(ids)).sort(function (a, b) {
        return a - b;
      });
    });
    var euTaxonomyIcon = computed(function () {
      var _EU_TAXONOMY_ICON_BY_;
      if (!props.euTaxonomy) return null;
      return (_EU_TAXONOMY_ICON_BY_ = EU_TAXONOMY_ICON_BY_TYPE[props.euTaxonomy]) !== null && _EU_TAXONOMY_ICON_BY_ !== void 0 ? _EU_TAXONOMY_ICON_BY_ : null;
    });
    var euTaxonomyLabel = computed(function () {
      if (!props.euTaxonomy) return '';
      var key = EU_TAXONOMY_LABEL_KEY_BY_TYPE[props.euTaxonomy];
      return key ? String(proxy.$t(key)) : '';
    });
    var euTaxonomyTooltip = computed(function () {
      return euTaxonomyLabel.value ? "".concat(String(proxy.$t('euTaxonomyTitle')), ": ").concat(euTaxonomyLabel.value) : '';
    });
    var irisCategories = computed(function () {
      var _props$irisCategories;
      return ((_props$irisCategories = props.irisCategories) !== null && _props$irisCategories !== void 0 ? _props$irisCategories : []).filter(function (category) {
        return (category === null || category === void 0 ? void 0 : category.id) != null && !!category.label;
      });
    });
    var hasContent = computed(function () {
      return sdgIds.value.length > 0 || !!euTaxonomyIcon.value || irisCategories.value.length > 0;
    });
    function sdgTooltip(sdgId) {
      var _catalog$sdgId;
      var catalog = proxy.$t('impactGoal.impacts.defineImpacts.classifyImpact.sdgInput.sdgs');
      var short = catalog === null || catalog === void 0 ? void 0 : (_catalog$sdgId = catalog[sdgId]) === null || _catalog$sdgId === void 0 ? void 0 : _catalog$sdgId.short;
      var detail = short ? "".concat(sdgId, ": ").concat(short) : String(sdgId);
      return "".concat(String(proxy.$t('sdgTitle')), ": ").concat(detail);
    }
    return {
      __sfc: true,
      props: props,
      proxy: proxy,
      sdgIds: sdgIds,
      euTaxonomyIcon: euTaxonomyIcon,
      euTaxonomyLabel: euTaxonomyLabel,
      euTaxonomyTooltip: euTaxonomyTooltip,
      irisCategories: irisCategories,
      hasContent: hasContent,
      sdgTooltip: sdgTooltip
    };
  }
});